import { classNames } from 'primereact/utils';

type TableHeaderWithUnitProps = {
  label: string;
  unit: string;
  alignEnd?: boolean;
};

/** A column header with its unit underneath, so the cells below can show the bare value. */
const TableHeaderWithUnit = ({ label, unit, alignEnd = false }: TableHeaderWithUnitProps) => {
  return (
    <div className={classNames('flex flex-column', { 'align-items-end': alignEnd })}>
      <span>{label}</span>
      <span className='text-xs font-normal'>{unit}</span>
    </div>
  );
};

export default TableHeaderWithUnit;
